module.exports = __webpack_public_path__ + "img/flight-land.7a4510d6.svg";